import EmptyState from './EmptyState';

const NoEmail = () => {
  return (
    <EmptyState
      title="Select or Write an Email"
      subtitle="To view if recipients are in Loxo, select or write an email."
    />
  );
};

export default NoEmail;
